import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  viewChild,
  inject,
} from '@angular/core';

import { Drawer } from 'primeng/drawer';
import { Route, RouterLinkComponent } from '@web/common';
import { Button } from 'primeng/button';
import { Icon } from '@web/shared/ui';
import { LocalStorageService } from '@web/core';

@Component({
  selector: 'app-cookie-banner',
  imports: [Drawer, RouterLinkComponent, Button],
  templateUrl: './cookie-banner.component.html',
  styleUrl: './cookie-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieBannerComponent implements OnInit {
  private readonly localStorage = inject(LocalStorageService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  protected visible = false;

  protected readonly drawerRef = viewChild.required(Drawer);
  protected readonly Route = Route;
  protected readonly Icon = Icon;

  private readonly cookieBannerKey = 'fc156ae2-11af-446d-a6d8-b9c364bb1e74';

  public ngOnInit(): void {
    if (this.shouldShowCookieBanner()) {
      this.visible = true;
      this.changeDetectorRef.detectChanges();
    }
  }

  public handleCloseClick(event: MouseEvent): void {
    this.drawerRef().close(event);
  }

  public handleAcceptClick(event: MouseEvent): void {
    this.drawerRef().close(event);
    this.localStorage.setItem(this.cookieBannerKey, 'true');
  }

  private shouldShowCookieBanner(): boolean {
    return !this.localStorage.isExists(this.cookieBannerKey);
  }
}
